import { render, staticRenderFns } from "./CreateOrderFromPms.vue?vue&type=template&id=97de8dfe"
import script from "./CreateOrderFromPms.vue?vue&type=script&lang=js"
export * from "./CreateOrderFromPms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports